var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShipmentDelivered = function SvgShipmentDelivered(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 20.7813H3.28125C2.70109 20.7813 2.14469 20.5508 1.73445 20.1405C1.32422 19.7303 1.09375 19.1739 1.09375 18.5938V3.28125C1.09375 2.70109 1.32422 2.14469 1.73445 1.73445C2.14469 1.32422 2.70109 1.09375 3.28125 1.09375H20.7813C21.3614 1.09375 21.9178 1.32422 22.328 1.73445C22.7383 2.14469 22.9688 2.70109 22.9688 3.28125V8.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9065 31.9944C28.8869 34.4108 28.5354 33.8508 23.0609 33.8508C20.4709 33.8508 19.1656 32.1635 18.4029 29.6887V29.6727L16.5946 23.5477V23.536C16.5041 23.2413 16.484 22.9294 16.536 22.6255C16.5879 22.3216 16.7104 22.034 16.8936 21.786C17.3074 21.2949 17.8591 20.9393 18.4773 20.7652H23.3029C24.0715 20.7652 24.7919 20.7652 25.1652 20.281C25.3493 20.0425 25.4761 19.7648 25.5357 19.4695C25.5954 19.1741 25.5864 18.869 25.5094 18.5777L24.3427 15.2235C24.2675 14.8481 24.3207 14.4584 24.4938 14.1169C24.6669 13.7754 24.9499 13.5021 25.2971 13.3408C25.6443 13.1796 26.0357 13.1398 26.4083 13.2279C26.7809 13.316 27.113 13.5268 27.3513 13.8265L32.1638 20.6442C32.3452 20.901 32.5856 21.1106 32.8646 21.2555C33.1437 21.4004 33.4535 21.4763 33.7679 21.4769",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 1.09375H8.75V12.0312H15.3125V1.09375Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShipmentDelivered, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shipment-delivered.07ed519c.svg";
export { ForwardRef as ReactComponent };